export default __webpack_public_path__ + "static/media/globalFiltersMenuIcon.f175068d.svg";